import { render, staticRenderFns } from "./EmployeeNewButton.vue?vue&type=template&id=fb641dd0&functional=true&"
import script from "./EmployeeNewButton.vue?vue&type=script&lang=ts&"
export * from "./EmployeeNewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports